import * as React from "react";
const SvgWebflow = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1080 674",
  width: "1em",
  height: "1em",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#146EF5",
  fillRule: "evenodd",
  d: "M1080 0 735.386 673.684H411.695l144.221-279.203h-6.471C430.464 548.934 252.942 650.61 0 673.684v-275.34s161.813-9.557 256.938-109.568H0V.006H288.77v237.509l6.481-.026L413.254.005h218.39V236.01l6.482-.01L760.555 0z",
  clipRule: "evenodd"
}));
export default SvgWebflow;
//# sourceMappingURL=Webflow.js.map